/* Alix Avien US — "Most popular shades" şeridi (alix-populer, 04.10.2026).
   1) Çipe tıklama: gerçek ton dairesine (.color-watches label) tıklatılır,
      böylece varyant, fiyat, galeri ve yapışkan çubuk temanın KENDİ yolundan
      güncellenir. Daire bir segment filtresiyle gizliyse önce "All" seçilir.
   2) Seçili durum: çipte .secili, "Color: X" başlığının yanında
      "Best seller" rozeti — yalnız seçili ton popülerse.
   JS yoksa: çip bir <label for=radyo>, tonu yine seçer. */
(function () {
  if (window.alixPopuler) return;
  window.alixPopuler = true;

  function serit() {
    var s = document.querySelectorAll('[data-alix-populer]');
    for (var i = 0; i < s.length; i++) if (s[i].getBoundingClientRect().height > 0) return s[i];
    return s[0] || null;
  }

  function senkron() {
    var s = serit();
    if (!s) return;
    var fs = s.closest('fieldset');
    if (!fs) return;
    var secim = fs.querySelector('.input-radio:checked');
    var ad = secim ? (secim.getAttribute('aria-label') || secim.value || '').trim() : '';
    var tonlar = (s.getAttribute('data-alix-tonlar') || '').split('||').map(function (t) { return t.trim(); });
    [].forEach.call(s.querySelectorAll('.alix-populer-cip'), function (c) {
      var on = !!secim && c.getAttribute('for') === secim.id;
      c.classList.toggle('secili', on);
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    var leg = fs.querySelector('legend');
    if (!leg) return;
    var r = leg.querySelector('.alix-populer-rozet');
    if (!r) {
      r = document.createElement('span');
      r.className = 'alix-populer-rozet';
      r.textContent = 'Best seller';
      leg.appendChild(r);
    }
    r.hidden = !(ad && tonlar.indexOf(ad) !== -1);
  }

  function gec() { setTimeout(senkron, 0); setTimeout(senkron, 200); setTimeout(senkron, 900); }

  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('.alix-populer-cip');
    if (!c) return;
    var hedef = document.getElementById(c.getAttribute('data-alix-hedef') || '');
    if (!hedef) { gec(); return; }   // hedef yoksa label-for kendi işini yapar
    e.preventDefault();
    if (hedef.classList.contains('alix-gizli')) {
      var fs = hedef.closest('fieldset');
      var hepsi = fs && fs.querySelector('.alix-segment-dugme[data-alix-filtre="hepsi"]');
      if (hepsi) hepsi.click();
    }
    hedef.click();
    gec();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('input-radio')) gec();
  });

  // Tema varyant değişiminde seçiciyi yeniden çiziyorsa şerit de yeniden gelir.
  var ilk = serit();
  var kok = (ilk && ilk.closest('.product-info')) || document.body;
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { gec(); return; }
  }).observe(kok, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', senkron);
  else senkron();
})();
